/**
 * DO NOT import colors.js into files. Use ../themes/default.js instead.
 */
export default {
    dark: '#0b1b34',
    black: '#000000',
    blue: '#0185ff',
    blueHover: '#B0D9FF',
    ivory: '#fffaf0',
    orange: '#FF7101',
    pink: '#F68DFE',
    green: '#03D47C',
    greenHover: '#00C271',
    greenPressed: '#35DD96',
    greenDisabled: '80E9BD',
    red: '#F25730',
    redHover: '#DE4822',
    redPressed: '#F57959',
    redDisabled: '#F8AA97',
    yellow: '#FED607',
    transparent: 'transparent',

    // Dark Mode Theme Colors
    greenAppBackground: '#061B09',
    greenHighlightBackground: '#07271F',
    greenBorders: '#1A3D32',
    greenBordersLighter: '#2B5548',
    greenIcons: '#8B9C8F',
    greenSupportingText: '#AFBBB0',
    white: '#E7ECE9',
    blueLink: '#5AB0FF',
    blueLinkHover: '#B0D9FF',
    blueLinkPreview: '#2EAAE2',
    greenDefaultButton: '#184E3D',
    greenDefaultButtonHover: '#2C6755',
    greenDefaultButtonPressed: '#467164',
    greenDefaultButtonDisabled: '#8BA69E',
    midnight: '#002140',

    // Brand Colors from Figma
    blue100: '#B0D9FF',
    blue200: '#8DC8FF',
    blue400: '#0185FF',
    blue500: '#0676DE',
    blue600: '#0164BF',
    blue700: '#003C73',
    blue800: '#002140',

    green100: '#B1F2D6',
    green200: '#8EECC4',
    green400: '#03D47C',
    green600: '#008C59',
    green700: '#085239',
    green800: '#002E22',

    yellow200: '#FFED8F',
    yellow400: '#FED607',
    yellow700: '#722B03',
    yellow800: '#401102',

    tangerine200: '#FFC68C',
    tangerine400: '#FF7101',
    tangerine700: '#780505',
    tangerine800: '#400000',

    pink200: '#FBCCFF',
    pink400: '#F68DFE',
    pink600: '#CF4CD9',
    pink700: '#712A76',
    pink800: '#49225B',

    ice200: '#CCF7FF',
    ice400: '#50EEF6',
    ice700: '#28736D',
    ice800: '#134038',

    // DEPRECATED COLORS. Do not reference these colors. Will be deleted in color switch PR.
    gray1: '#FAFAFA',
    gray2: '#ECECEC',
    gray3: '#C6C9CA',
    gray4: '#7D8B8F',
    oldRed: '#fc3826',
    oldRedHover: '#e13826',
    oldRedDisabled: '#fea29a',
};
